import type { NskResponse } from '~/models/Api';
import type { StaffParam } from '~/models/Staff';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';
import { generatePath } from '~/utils/generatePath';

export const create = async (staff: StaffParam): Promise<NskResponse<void>> =>
  postRequest(generatePath('/staffs'), { staff });

export const update = async (
  staff: StaffParam,
  staffId: number
): Promise<NskResponse<void>> =>
  putRequest(generatePath('/staffs/:id', { id: staffId }), { staff });

export const updateEnabled = async (
  staffId: number,
  enabled: boolean
): Promise<NskResponse<void>> =>
  putRequest(generatePath('/staffs/:id/update_enabled', { id: staffId }), {
    enabled
  });

export const login = async (
  id: number,
  password: string | null
): Promise<NskResponse<void>> =>
  postRequest(generatePath('/staffs/login'), { id, password });

export const logout = async (): Promise<NskResponse<void>> =>
  deleteRequest(generatePath('/staffs/logout'));
